<micro-select-combo #sel
              placeholder="Undefined"
              [mode]="mode"
              [(id)]="characterSet"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
              [blur]="onTouched"
>
</micro-select-combo>
